import { storage, STORAGE_KEYS } from '@/shared/lib';
import _ from 'lodash';

const facilitySelection = {
  setUserSupportFacilities: (supportFacilities: any) => {
    /**
     * Projects the supportFacilities collection into a reduced shape, keeping only id, name, canViewFlaggedStudies, and programs for each entry. Built with a lodash map that spreads each facility before overriding those fields.
     *
     * @returns Array of reduced support-facility objects.
     */
    const reducedSupportFacilities = _.map(supportFacilities, (supportFacility) => ({
      ...supportFacility,
      id: supportFacility?.id,
      name: supportFacility?.name,
      canViewFlaggedStudies: supportFacility?.canViewFlaggedStudies,
      programs: supportFacility?.programs,
    }));
    storage.setJson(STORAGE_KEYS.userSupportFacilities, reducedSupportFacilities);
  },

  userSupportFacilities: () => storage.getJson<any[]>(STORAGE_KEYS.userSupportFacilities, []),

  setSelectedFacilityLocalStorage: (selectedFacilityLocalStorage: any) => {
    storage.setJson(STORAGE_KEYS.selectedFacilityLocalStorage, selectedFacilityLocalStorage);
  },

  selectedFacilityLocalStorage: () =>
    storage.getJson<any>(STORAGE_KEYS.selectedFacilityLocalStorage, {}),

  setSelectedTypeSeePatientsLocalStorage: (selectedTypeSeePatientsLocalStorage: any) => {
    storage.setJson(
      STORAGE_KEYS.selectedTypeSeePatientsLocalStorage,
      selectedTypeSeePatientsLocalStorage,
    );
  },

  selectedTypeSeePatientsLocalStorage: () =>
    storage.getJson<any>(STORAGE_KEYS.selectedTypeSeePatientsLocalStorage, {}),
};

export default facilitySelection;
